import { Component, Input, Output, OnInit, EventEmitter, HostListener, ElementRef } from '@angular/core';
import { HeadCount } from 'src/app/pap-creation/pap-dto/pap-dto';

@Component({
  selector: 'app-poll-creation-headcount',
  templateUrl: 'poll-creation-headcount.component.html',
  styleUrls: ['./poll-creation-headcount.component.less', '../../../shared/common.less'],
})

export class PollCreationHeadcountComponent implements OnInit {
  @Input() headcount: HeadCount;
  @Output() headcountChange = new EventEmitter<HeadCount>();
  @Output() numberOfCollegesChange = new EventEmitter<number>();

  needPap: boolean = undefined;
  minDate: string;
  suggestedValue: number = 0;
  suggestionChecked: boolean = true;
  showTooltip: boolean = false;
  Infinity = Infinity;

  readonly fullMembersRanges = [
    { min: 11, max: 24, members: 1 },
    { min: 25, max: 49, members: 2 },
    { min: 50, max: 74, members: 4 },
    { min: 75, max: 99, members: 5 },
    { min: 100, max: 124, members: 6 },
    { min: 125, max: 149, members: 7 },
    { min: 150, max: 174, members: 8 },
    { min: 175, max: 199, members: 9 },
    { min: 200, max: 249, members: 10 },
    { min: 250, max: 399, members: 11 },
    { min: 400, max: 499, members: 12 },
    { min: 500, max: 599, members: 13 },
    { min: 600, max: 799, members: 14 },
    { min: 800, max: 899, members: 15 },
    { min: 900, max: 999, members: 16 },
    { min: 1000, max: 1249, members: 17 },
    { min: 1250, max: 1499, members: 18 },
    { min: 1500, max: 1749, members: 20 },
    { min: 1750, max: 1999, members: 21 },
    { min: 2000, max: 2249, members: 22 },
    { min: 2250, max: 2499, members: 23 },
    { min: 2500, max: 2999, members: 24 },
    { min: 3000, max: 3499, members: 25 },
    { min: 3500, max: 3999, members: 26 },
    { min: 4000, max: 4249, members: 26 },
    { min: 4250, max: 4749, members: 27 },
    { min: 4750, max: 4999, members: 28 },
    { min: 5000, max: 5749, members: 29 },
    { min: 5750, max: 5999, members: 30 },
    { min: 6000, max: 6999, members: 31 },
    { min: 7000, max: 8249, members: 32 },
    { min: 8250, max: 8999, members: 33 },
    { min: 9000, max: 9999, members: 34 },
    { min: 10000, max: Infinity, members: 35 }
  ];

  constructor(
    private elementRef: ElementRef
  ) {
    const today = new Date();
    this.minDate = today.toISOString().substring(0, 10);
  }

  onHeadcountChange() {
    this.headcountChange.emit(this.headcount);
  }

  onNumberOfCollegesChange() {
    this.onHeadcountChange()
    this.numberOfCollegesChange.emit(this.headcount.numberOfColleges);
  }

  calculateFullMembers() {
    const total = this.headcount.total;

    const range = this.fullMembersRanges.find(r => total >= r.min && total <= r.max);
    this.suggestedValue = range ? range.members : 0;
    if (this.suggestionChecked) {
      this.headcount.fullMembers = this.suggestedValue;
    }

    this.onHeadcountChange()
    return this.suggestedValue;
  }

  onSuggestionChange() {
    if (this.suggestionChecked) {
      this.headcount.fullMembers = this.suggestedValue;
      this.onHeadcountChange();
    }
  }

  toggleTooltip() {
    this.showTooltip = !this.showTooltip;
  }

  @HostListener('document:click', ['$event'])
  onClickOutside(event: MouseEvent) {
    if (this.showTooltip) {
      const clickedInside = this.elementRef.nativeElement.querySelector('.tooltip-container')?.contains(event.target) ||
                           this.elementRef.nativeElement.querySelector('.tooltip-trigger')?.contains(event.target);
      if (!clickedInside) {
        this.showTooltip = false;
      }
    }
  }

  ngOnInit(): void {
  }
}
